import { AsyncAction, CommanderThunkAction } from '@mews-commander/types';
import { getBase64, RouterService } from '@mews/framework';
import { getAppConfiguration } from '@mews-commander/data-access';
import { createFetchAction, notEmpty } from '@mews-commander/utils';
import { getCurrentEnterpriseId } from '@mews-commander/core';
import { setTasks } from '../ducks/tasks';
import prefix from '../prefix';
import { setProfiles } from '../ducks/profiles';

const TASK_FETCH = prefix('TASK_FETCH');
const TASK_UPDATE = prefix('TASK_UPDATE');
const TASK_IMAGE_UPLOAD = prefix('TASK_IMAGE_UPLOAD');

const fetch =
    ({ enterpriseId, ...other }: $TSFixMe) =>
    (dispatch: $TSFixMe, getState: $TSFixMe, { container }: { container: () => CommanderContainer }) => {
        const promise = container()
            .taskComponent.getAll({ enterpriseId, ...other })
            .then(({ tasks, profiles }: $TSFixMe) => {
                if (notEmpty(tasks)) {
                    dispatch(setTasks({ tasks, scope: enterpriseId }));
                }

                if (notEmpty(profiles)) {
                    dispatch(setProfiles(profiles));
                }
            });

        return dispatch(createFetchAction(TASK_FETCH, promise));
    };

export const fetchCurrentEnterpriseTasks = (params: $TSFixMe) => (dispatch: $TSFixMe) => {
    const enterpriseId = getCurrentEnterpriseId();
    return dispatch(fetch({ enterpriseId, ...params }));
};

export const fetchCurrentEnterpriseTaskById = (taskId: $TSFixMe) =>
    fetchCurrentEnterpriseTasks({ taskIds: [taskId], extent: { profiles: true } });

export const updateTask =
    ({ taskId, departmentId, assigneeProfileId, name, description, serviceOrderId, deadlineUtc }: $TSFixMe) =>
    (dispatch: $TSFixMe, getState: $TSFixMe, { container }: { container: () => CommanderContainer }) => {
        const enterpriseId = getCurrentEnterpriseId();

        const promise = container()
            .taskComponent.update({
                taskId,
                enterpriseId,
                departmentId,
                assigneeProfileId,
                name,
                description,
                serviceOrderId,
                deadlineUtc,
                extent: { profiles: true },
            })
            .then(({ tasks, profiles }: $TSFixMe) => {
                if (notEmpty(tasks)) {
                    dispatch(setTasks({ tasks, scope: enterpriseId }));
                }

                if (notEmpty(profiles)) {
                    dispatch(setProfiles(profiles));
                }
            });
        return dispatch(createFetchAction(TASK_UPDATE, promise));
    };

interface ImageData {
    imageId: string;
    url: string;
}
export const uploadTaskImage =
    (image: Blob | File, taskId?: string): CommanderThunkAction<AsyncAction<ImageData>> =>
    async (dispatch, getState, { repositories }) => {
        const { imageBaseUrl } = getAppConfiguration();
        const base64 = await getBase64(image);
        const promise = repositories.tasks.uploadImages({ taskId, imageBase64Datas: [base64] }).then(
            ({ uploadedImageIds: [imageId] }): ImageData => ({
                imageId,
                url: RouterService.imageUrl(imageId, imageBaseUrl),
            })
        );
        return dispatch(createFetchAction(TASK_IMAGE_UPLOAD, promise));
    };
